import styled from 'styled-components'

import { ModalCardContentStyled, ModalCardHeaderStyled } from '@ui/blocks/Modal'

interface IConfirmationModalStyledProps {}

export const ConfirmationModalStyled = styled.div<IConfirmationModalStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .icon-container {
    flex-shrink: 1;
    padding-top: ${(props) => props.theme.typography.pxToRem(40)};
    padding-left: ${(props) =>
      props.theme.box.horizontalPadding(props.theme.typography.htmlFontSize)};
  }

  .content-container {
    flex-grow: 1;
  }

  .icon-container
    + .content-container
    ${/* sc-selector */ ModalCardContentStyled},
    .icon-container
    + .content-container
    ${ModalCardHeaderStyled} {
    padding-left: ${(props) => props.theme.space.small};
  }
`
